var rich_content_viewer_default = {
  "fontElementMap": "sxDE7",
  "wrapper": "j2gFi",
  "pluginContainerMobile": "_0m6Y7",
  "viewer": "_7JfRy",
  "android": "DRBtY",
  "rootedTraversedContent": "_5dMJI",
  "atomic": "NLkKh",
  "toolbar": "_4oH-T",
  "block": "YFKHD"
};
export {
  rich_content_viewer_default as default
};
//# sourceMappingURL=rich-content-viewer-scss.js.map
